// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__4n5Ho","groups":"Skills_groups__2ftVW","group":"Skills_group__uIsdb"};